import {jwtDecode} from 'jwt-decode';
import {Session} from '../types';

export const getInitialRedirectPath = (token: string, returnUrl?: string | null) => {
  let to;
  const session = jwtDecode<Session>(token);

  if (session.isPasswordChangeRequired === 'true') {
    to = '/set-password';
  } else if (!session.subscriptionType) {
    to = '/welcome';
  } else if (session.subscriptionIsValid === 'true') {
    to = returnUrl ?? '/biotwins';
  } else if (session.subscriptionValidUntil != null) {
    to = '/profile/membership';
  } else {
    to = '/subscription';
  }

  return to;
};
